<template>
  <v-container fluid>
    <ModalTag
      :modalTag="modalTag"
      :editTag="editTagObj"
      @close="closeModalTag"
    />
    <Grid
      title="Tags"
      :headers="headers"
      :items="tags"
      @novo="modalTag = true"
      @edit="editTag"
      @destroy="destroyTag"
      @atualiza="getTags"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Grid from '@/components/shared/Grid';
import ModalTag from '@/components/tag/ModalTag';

export default {
  name: 'Tags',
  data: () => ({
    modalTag: false,
    editTagObj: null,
    headers: [
      {
        text: 'Descrição',
        align: 'start',
        value: 'descricao',
      },
      { text: 'Cor', value: 'cor' },
      { text: 'Ações', value: 'actions', sortable: false },
    ],
  }),
  components: {
    Grid,
    ModalTag
  },
  computed: {
    ...mapGetters(['tags'])
  },
  methods: {
    ...mapActions(['fetchTags', 'deleteTag']),
    closeModalTag() {
      this.editTagObj = null;
      this.modalTag = false;
    },
    getTags() {
      this.fetchTags();
    },
    editTag(tag) {
      this.editTagObj = { ...tag };
      this.modalTag = true;
    },
    destroyTag(tag) {
      if (confirm(`Tem certeza que deseja excluir o tag: ${tag.descricao}?`)) {
        this.deleteTag(tag._id);
      }
    }
  },
  created() {
    this.getTags();
  }
}
</script>

<style>

</style>